import React from "react";

import { Icon, WrappingIconProps } from "../Icon";

export const GuaranteedIcon = (props: WrappingIconProps) => {
  return (
    <Icon width="16px" height="16px" viewBox="0 0 16 16" fill="none" {...props}>
      <g clipPath="url(#clip0_6140_27159)">
        <circle cx="8" cy="8" r="8" fill="var(--mode-vector-primary-weakest)" />
        <g clipPath="url(#clip1_6140_27159)">
          <path
            d="M7.81836 8.12207H10.4844V11.7061C10.11 11.8298 9.72266 11.9258 9.32227 11.9941C8.92188 12.0625 8.47266 12.0967 7.97461 12.0967C7.2487 12.0967 6.63346 11.9535 6.12891 11.667C5.6276 11.3773 5.24674 10.959 4.98633 10.4121C4.72591 9.86198 4.5957 9.19954 4.5957 8.4248C4.5957 7.67936 4.74056 7.0332 5.03027 6.48632C5.31999 5.93619 5.74154 5.51139 6.29492 5.21191C6.84831 4.90918 7.51888 4.75781 8.30664 4.75781C8.69401 4.75781 9.06836 4.79688 9.42969 4.875C9.79427 4.94987 10.1279 5.05403 10.4307 5.1875L10.0205 6.15429C9.77962 6.04036 9.50944 5.94433 9.20996 5.86621C8.91048 5.78808 8.59961 5.74902 8.27734 5.74902C7.76628 5.74902 7.3252 5.8597 6.9541 6.08105C6.58626 6.30241 6.30306 6.61491 6.10449 7.01855C5.90592 7.41894 5.80664 7.89257 5.80664 8.43945C5.80664 8.97005 5.88639 9.43554 6.0459 9.83593C6.2054 10.2363 6.45443 10.5488 6.79297 10.7734C7.13477 10.9948 7.57585 11.1055 8.11621 11.1055C8.38639 11.1055 8.61589 11.0908 8.80469 11.0615C8.99349 11.0322 9.16764 10.9997 9.32715 10.9639V9.12304H7.81836V8.12207Z"
            fill="var(--theme-neutral-1000)"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_6140_27159">
          <rect width="16" height="16" fill="var(--theme-neutral-0)" />
        </clipPath>
        <clipPath id="clip1_6140_27159">
          <rect
            width="7"
            height="9"
            fill="var(--theme-neutral-0)"
            transform="translate(4 4)"
          />
        </clipPath>
      </defs>
    </Icon>
  );
};
